import { render, staticRenderFns } from "./RewardHistory.vue?vue&type=template&id=703f0f80"
import script from "./RewardHistory.vue?vue&type=script&lang=js"
export * from "./RewardHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports